import React from "react";
import PropTypes from "prop-types";
import { Grid, Row, Col, Table } from "react-bootstrap";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import "../../node_modules/react-bootstrap-table/dist/react-bootstrap-table-all.min.css";
import { FormattedMessage } from "react-intl";
import { injectIntl, intlShape } from "react-intl";

import BreadcrumbContainer from "../grundelemente/BreadcrumbContainer";
import { getComponentNameLong } from "../model/util/Components";
import { almigOrange } from "../grundelemente/AlmigTheme";
import { getUnit, formatUnitValue } from "../einheiten/Units";
import { getFehlertext } from "../model/Fehlertexte";
import { compressorStatusImage, makeUndefinedCompressor } from "../model/Kompressor";
import { masterDisplayedStatusTNR } from "../model/Verbund";

import StoerspeicherInfoPanelContainer from "./StoerspeicherInfoPanelContainer";
import "./Stoerspeicher.css";

const makeSelectRowProp = changeSelected => ({
	mode: "radio",
	bgColor: almigOrange,
	hideSelectColumn: true,
	clickToSelect: true,
	onSelect: changeSelected
});

const formatDate = (cell, intl) => {
	return intl.formatDate(cell) + " " + intl.formatTime(cell, {
		hour: "2-digit",
		minute: "2-digit",
		second: "2-digit"
	});
};

const formatComponent = (cell, compressors, intl) => {
	return getComponentNameLong(cell, compressors, intl);
};

const formatType = bit_index => {
	let color_style = "error-error";
	if (bit_index < 1 * 16) {
		color_style = "error-maintenance";
	} else if (bit_index < 4 * 16) {
		color_style = "error-warning";
	}
	return <div className={"error-type " + color_style} />;
};

const formatPlantStatus = master => (
	<FormattedMessage id={ masterDisplayedStatusTNR(master) } />
);

const formatValue = (value, unit, intl) => {
	return formatUnitValue(value, unit, intl) + " " + unit.genUnitText(intl);
};

const genCompressor = (compressor, contexts) => {
	let cindex = compressor.cindex;
	let context = contexts.find(ctx => ctx.cindex === cindex);
	let comp = context || makeUndefinedCompressor(cindex);
	return (
		<div className="status-anzeige" key={compressor.cindex}>
			<span>{cindex + 1}</span>
			{compressorStatusImage(comp)}
		</div>
	);
};

const Stoerspeicher = props => (
	<Grid className="Stoerspeicher">
		<Row>
			<Col xs={12}>
				<BreadcrumbContainer />
			</Col>
		</Row>
		<Row>
			<Col sm={12} md={9} className="Mittelspalte">
				<BootstrapTable data={props.error_log} striped hover
					height="315px" scrollTop="Top" className="log-table"
					selectRow={makeSelectRowProp(props.changeSelected)}
					options={{noDataText: <FormattedMessage id="No data to display." />}}>
					<TableHeaderColumn isKey dataField="date" width="175"
						dataFormat={(cell) => {
							return formatDate(cell, props.intl);
						}}>
						<FormattedMessage id="Timestamp" />
					</TableHeaderColumn>
					<TableHeaderColumn dataField="componentIndex" width="175" dataFormat={(cell) => {
						return formatComponent(cell, props.compressors, props.intl);
					}}>
						<FormattedMessage id="Component" />
					</TableHeaderColumn>
					<TableHeaderColumn dataField="bitIndex" width="40"
						dataFormat={formatType} />
					<TableHeaderColumn dataField="bitIndex"
						dataFormat={(cell, row) => {
							/* das muss hier rein, wegen sichtbarkeit der props! */
							return getFehlertext(row.componentIndex, cell, props.fehlertexte, props.locale);
						}}>
						<FormattedMessage id="Error text" />
					</TableHeaderColumn>
				</BootstrapTable>
				{!props.selected
					? <div />
					: <div className="error-details">
						<Table><tbody>
							<tr>
								<td sm={5} md={2}>
									<FormattedMessage id="Master control" />
								</td>
								<td sm={4} md={2}>
									{formatPlantStatus(props.selected.plantContext)}
								</td>
								<td sm={5} md={2}>
									<FormattedMessage id="Station delivery volume" />
								</td>
								<td sm={4} md={2}>
									{formatValue(props.selected.plantContext.delivery_volume_m3min,
										getUnit(props.units["volume_over_minutes"]), props.intl)}
								</td>
							</tr>
							<tr>
								<td sm={5} md={2}>
									<FormattedMessage id="System pressure" />
								</td>
								<td sm={4} md={2}>
									{formatValue(props.selected.plantContext.line_pressure_bar,
										getUnit(props.units["pressure"]), props.intl)}
								</td>
								<td sm={5} md={2}>
									<FormattedMessage id="Station volume flow" />
								</td>
								<td sm={4} md={2}>
									{formatValue(props.selected.plantContext.volume_flow_m3min,
										getUnit(props.units["volume_over_minutes"]), props.intl)}
								</td>
							</tr>
						</tbody></Table>
						<div>
							{props.compressors.map(compressor =>
								genCompressor(compressor, props.selected.compressorContexts))}
						</div>
					</div>
				}
			</Col>
			<Col sm={12} md={3}>
				<StoerspeicherInfoPanelContainer />
			</Col>
		</Row>
	</Grid>
);

Stoerspeicher.propTypes = {
	compressors: PropTypes.arrayOf(PropTypes.object).isRequired,
	units: PropTypes.object.isRequired,
	error_log: PropTypes.arrayOf(PropTypes.object).isRequired,
	fehlertexte: PropTypes.object.isRequired,
	locale: PropTypes.string.isRequired,
	selected: PropTypes.object,
	changeSelected: PropTypes.func.isRequired,
	intl: intlShape.isRequired
};

export default injectIntl(Stoerspeicher);
